import 'isomorphic-fetch'; // This import installs `fetch` globally (to support testing)
import { BACK_TO_SIGN_IN } from './ResetPasswordConstants';

export default function backToSignIn() {
  return {
    type: BACK_TO_SIGN_IN,
  };
}
